import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { LOGO_URL } from "../lib/constants";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f8f9fa] px-6">
      <div className="w-full max-w-md bg-white border border-[#cbd5e1] rounded-2xl p-8 shadow-[0_20px_60px_-30px_rgba(10,37,64,0.4)]">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="HSA" className="h-20 w-20 mx-auto mb-3 object-cover rounded-lg" />
          <h1 className="font-serif-hsa text-2xl font-bold text-[#0a2540]">Admin Sign In</h1>
          <p className="text-sm text-slate-500 mt-1">HSA Service Hub administration</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-[#0a2540] font-medium">Email</Label>
            <Input data-testid="admin-login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 h-11" placeholder="admin@hsaservicehub.com" required />
          </div>
          <div>
            <Label className="text-[#0a2540] font-medium">Password</Label>
            <Input data-testid="admin-login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 h-11" placeholder="••••••••" required />
          </div>
          <Button data-testid="admin-login-submit" type="submit" disabled={loading}
            className="w-full h-11 bg-[#0a2540] hover:bg-[#1e6dd8] text-white font-semibold">
            {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Signing in...</> : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
}
